import { render, staticRenderFns } from "./stackChart2.vue?vue&type=template&id=15ed4e57&"
import script from "./stackChart2.vue?vue&type=script&lang=js&"
export * from "./stackChart2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports